import React from 'react'
import { FaLink } from 'react-icons/fa'
import { TfiReload } from 'react-icons/tfi';
import { Link } from 'react-router-dom'

const StatCard = ({ title, value, subtitle, icon: Icon, color, linkTo, showLink = true, additionalInfo, onRefresh }) => {

  const refreshPage = () => {
    onRefresh();
  };

  const formatNumber = (num) => {

    const numValue = parseFloat(num);
    if (isNaN(numValue)) {
      return num;
    }

    return numValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className={`p-2 rounded-lg ${color}`}>
          <Icon className="h-5 w-5 text-white" />
        </div>
        <button onClick={refreshPage} className="text-gray-400 hover:text-gray-600">
          <TfiReload className="text-[16px]" />
        </button>
      </div>

      <div className="space-y-2">
        <h3 className="text-2xl font-semibold text-gray-900">{formatNumber(value)}</h3>
        <p className="text-sm text-gray-600">{title}</p>
        {subtitle && (
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">{subtitle}</span>
            {showLink && linkTo && (
              <Link to={linkTo} className="text-blue-600 hover:text-blue-700">
                <FaLink className="text-[12px]" />
              </Link>
            )}
          </div>
        )}
        {additionalInfo && (
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">{additionalInfo}</span>
            {showLink && linkTo && (
              <Link to={linkTo} className="text-blue-600 hover:text-blue-700">
                <FaLink className="text-[12px]" />
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default StatCard